<ion-header>
  <ion-toolbar mode="ios">
    <ion-title text-center> Add Notes </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <form [formGroup]="notesForm" name="notesForm">
      <ion-row>
        <ion-col size="3">
          <ion-item input-item lines="none">
            <ion-label
              text-small
              class="ion-text-center ion-no-margin select-role-txt"
              >Select Role</ion-label
            >
          </ion-item>
        </ion-col>
        <ion-col size="6">
          <div>
            <p-dropdown
              [options]="roles"
              formControlName="selectedRole"
              name="selectedRole"
            ></p-dropdown>
          </div>
        </ion-col>
        <ion-col size="12">
          <ion-item
            input-item=""
            class="ion-padding-top"
            centered=""
            style="width: 95% !important"
            lines="none"
          >
            <ion-textarea
              centered=""
              font-medium=""
              formControlName="note"
              name="note"
              placeholder="Write your notes here"
            ></ion-textarea>
          </ion-item>
        </ion-col>
      </ion-row>
    </form>
  </ion-grid>
</ion-content>
<ion-footer no-box-shadow>
  <ion-grid>
    <ion-row>
      <ion-col size="6" offset="3">
        <ion-button
          size="large"
          expand="block"
          text-regular
          [disabled]="!notesForm.valid"
          color="primary"
          (click)="addNotes()"
          >Save</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
